<label class="mb-0" *ngIf="tipoSelectedDesignado==='UASG'">Unidade catalogadora</label>
<label class="mb-0" *ngIf="tipoSelectedDesignado==='CATALOGADOR'">Catalogador</label>
<select  [(ngModel)]="selectedDesignado" class="custom-select select-input">
  <option [ngValue]="undefined" [disabled]="true">--Selecione--</option>
  <option *ngFor="let item of activeList" [ngValue]="item">{{item.displayName}}</option>
</select>